export default {
    SKIP: 'SKIP',
    CRITICAL: 'CRITICAL',
    REDIRECT_HOME: 'REDIRECT_HOME',
    DEFAULT: 'DEFAULT'
};
